export default "/assets/398360dd034c633f.svg"